import '../styles/index.scss';
import {TweenMax, Power4, Back} from "gsap";

let currentScene = null
let originalDragPosition = {}
let timerOn = true
let rawTime = 0
let seconds = 0
let skeletonPieces
let droppedParts = 0
const TOTAL_PARTS = 16
var orientModal, orientButton

window.initialise = (stage, currentMC) => {
	if (currentScene != null)
		return

	stage.enableMouseOver(15)
	createjs.Touch.enable(stage)
	stage.snapToPixelEnabled = true;

	currentScene = currentMC
	let buttons = ['restartBtn', 'helpBtn', 'showImageBtn', 'timerBtn', 'playAgainBtn']
	skeletonPieces = ['skull', 'humerusLeft', 'humerusRight', 'radiusLeft', 'radiusRight', 'ribs', 'spine', 'handLeft', 'handRight', 'pelvis', 'femurLeft', 'femurRight', 'fibulaLeft', 'fibulaRight', 'feetLeft', 'feetRight']
	buttons.forEach (function(btn) {
		currentMC[btn].cursor ='pointer'
		currentMC[btn].on('rollover', buttonMouseOverAnimation)
		currentMC[btn].on('rollout', buttonMouseOutAnimation)
		currentMC[btn].on('click', eval(`${btn}Click`))
	})
	skeletonPieces.forEach(function(skeletonPiece) {
		currentMC[skeletonPiece].cursor ='pointer'
		currentMC[skeletonPiece].on('mousedown', skeletonPieceMouseDown)
		currentMC[skeletonPiece].on('pressmove', skeletonPieceMove)
		currentMC[skeletonPiece].on('pressup', skeletonPieceUp)
	})

	let timer = createjs.Ticker
	timer.on("tick", handleTick);

	let currentModal = currentMC.helpBox.Graphics
	console.log(currentModal)
	setTimeout(() => {
		currentModal.backBtn.cursor ='pointer'
		currentModal.backBtn.on('rollover', buttonMouseOverAnimation)
		currentModal.backBtn.on('rollout', buttonMouseOutAnimation)
		currentModal.backBtn.on('click', backBtnClick)
		currentModal.overlay.on('click', (event) => {event.stopPropagation()})
	}, 500)

	orientModal = document.getElementById('rotate_modal')
	orientButton = document.getElementById('orientButton')
	orientButton.onclick = () => {orientModal.style.display = 'none'}

}

const skeletonPieceMouseDown = (event) => {
	let parent = event.currentTarget.parent
	originalDragPosition.x = event.currentTarget.x
	originalDragPosition.y = event.currentTarget.y
	originalDragPosition.index = parent.getChildIndex(event.currentTarget)
	parent.setChildIndex(event.currentTarget, parent.getNumChildren() - 1)

	playSound(require('../assets/audio/pickup.mp3'))
}

const skeletonPieceMove = (event) => {
	
	event.currentTarget.x = event.stageX
	event.currentTarget.y = event.stageY
}

const skeletonPieceUp = (event) => {
	let target = currentScene[event.currentTarget.name + 'Target']
	let pt = target.globalToLocal(event.stageX, event.stageY)
	if (target.hitTest(pt.x, pt.y)) {
		// event.currentTarget.visible = false
		TweenMax.to(event.currentTarget, 0.1, { alpha: 0, ease: Power4.easeOut })
		currentScene.setChildIndex(event.currentTarget, originalDragPosition.index)
		TweenMax.fromTo(target, 0.3, {scaleX: 0, scaleY: 0, alpha: 0.1}, {scaleX: 1, scaleY: 1, alpha: 1, ease: Back.easeOut})
		playSound(require('../assets/audio/correct.mp3'))
		droppedParts++;

		if (droppedParts == TOTAL_PARTS) {
			timerOn = false
			droppedParts = 0
			currentScene.gotoAndStop(1)
		}
	} else {
		playSound(require('../assets/audio/wrong.mp3'))
		/* TweenMax.to(event.currentTarget, 0.5, {x: originalDragPosition.x, y: originalDragPosition.y, ease: Back.easeOut, ocComplete: () => {
			currentScene.setChildIndex(event.currentTarget, originalDragPosition.index)
		}}) */
	} 
	TweenMax.to(event.currentTarget, 0.5, {x: originalDragPosition.x, y: originalDragPosition.y, ease: Back.easeOut, ocComplete: () => {
		currentScene.setChildIndex(event.currentTarget, originalDragPosition.index)
	}})
}

const buttonMouseOverAnimation = (event) => {
	event.currentTarget.gotoAndStop(1)
}

const buttonMouseOutAnimation = (event) => {
	event.currentTarget.gotoAndStop(0)
}

const playAgainBtnClick = (event) => {
	currentScene.gotoAndStop(0)
	restartBtnClick(event)
}

const restartBtnClick = (event) => {
	rawTime = 0
	seconds = 0
	timerOn = true
	currentScene.timerBtn.timerOnTxt.visible = false
	currentScene.timerBtn.timerOffTxt.visible = true
	skeletonPieces.forEach(function(skeletonPiece) {
		// currentScene[skeletonPiece].visible = true
		TweenMax.to(currentScene[skeletonPiece], 1, { alpha: 1, ease: Power4.easeOut })
		TweenMax.fromTo(currentScene[skeletonPiece + 'Target'], 0, {alpha: 1}, {alpha: 0.01, ease: Back.easeOut})
	})
	playSound(require('../assets/audio/place.mp3'))
}

const helpBtnClick = (event) => {
	if (currentScene.helpBox.alpha > 0.1)
		return

	timerOn = false	
	TweenMax.to(currentScene.helpBox, 0.5, { alpha: 1, ease: Power4.easeOut })
	playSound(require('../assets/audio/place.mp3'))
}

const backBtnClick = (event) => {
	if (currentScene.helpBox.alpha > 1)
		return

	if (currentScene.timerBtn.timerOffTxt.visible) {
		timerOn = true
	}

	TweenMax.to(currentScene.helpBox, 0.5, { alpha: 0, ease: Power4.easeOut })
	playSound(require('../assets/audio/place.mp3'))
}

const showImageBtnClick = (event) => {
	if (currentScene.showImage.alpha > 0)
		return

	TweenMax.to(currentScene.showImage, 0.5, { alpha: 0.4, ease: Power4.easeOut })
	setTimeout(() => {
		TweenMax.to(currentScene.showImage, 0.5, { alpha: 0, ease: Power4.easeIn })
	}, 5000)
	playSound(require('../assets/audio/place.mp3'))
}

const timerBtnClick = (event) => {
	let timerBtn = event.currentTarget
	if (!timerOn) {
		timerBtn.timerOnTxt.visible = false
		timerBtn.timerOffTxt.visible = true
	} else {
		timerBtn.timerOnTxt.visible = true
		timerBtn.timerOffTxt.visible = false
	}
	timerOn = !timerOn
	playSound(require('../assets/audio/place.mp3'))
}

const handleTick = (event) => {
	if (timerOn) {
		rawTime += event.delta/1000
		let newVal = parseInt(rawTime)
		if (seconds != newVal) {
			seconds = newVal
			displayTime(seconds)
			playSound(require('../assets/audio/timer.mp3'))
		}
	}
}

const displayTime = (totalSeconds) => {
	let minutes = Math.floor(totalSeconds / 60);
	let seconds = totalSeconds - (minutes * 60)
	let minutesText, secondsText = ''

	minutesText = (minutes < 10) ? ('0' + minutes) : minutes
	secondsText = (seconds < 10) ? ('0' + seconds) : seconds
	currentScene.timerText.text = minutesText + ':' + secondsText
}

const playSound = (sound) => {
	if (sound) {
    var audio = new Audio(sound)
    audio.play()
  }
}
